var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66669 6H13.3334M4.66669 2V4M5.33335 8H4.66669M7.33335 8H6.66669M9.33335 8H8.66669M11.3334 8H10.6667M5.33335 9.33333H4.66669M7.33335 9.33333H6.66669M9.33335 9.33333H8.66669M11.3334 9.33333H10.6667M5.33335 10.6667H4.66669M7.33335 10.6667H6.66669M9.33335 10.6667H8.66669M11.3334 10.6667H10.6667M5.33335 12H4.66669M7.33335 12H6.66669M9.33335 12H8.66669M11.3334 12H10.6667M11.3334 2V4M12.6667 3.33333H3.33335C2.96469 3.33333 2.66669 3.632 2.66669 4V13.3333C2.66669 13.7013 2.96469 14 3.33335 14H12.6667C13.0354 14 13.3334 13.7013 13.3334 13.3333V4C13.3334 3.632 13.0354 3.33333 12.6667 3.33333Z",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIconWhite);
export default __webpack_public_path__ + "static/media/CalendarIconWhite.b3bf435572f6ed25e90f6fc9ffcfcc9b.svg";
export { ForwardRef as ReactComponent };